/** 
 * Set cookie
 * @function docSetCookie
 * @param {path} path
 * @param {value} cname
 * @param {value} cvalue
 * @param {value} exdays
*/


const docSetCookie = (path, cname, cvalue, exdays) => {
    let p = ('' != path) ? path : '/';
    let d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = (0 != exdays) ? d.toUTCString() : '';
    document.cookie = cname + '=' + cvalue + '; expires=' + expires + '; path=' + p;
};

/**  
 * Unset cookie
 * @functiondocUnsetCookie
 * @param {value} name
*/
const docUnsetCookie = (name) => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
};

/**
 * Get Cookie
 * @functiondocGetCookie
 * @param {value} name
*/
const functiondocGetCookie = (search) => {
    let val = '';

    if ('' != search) {
        let bits = document.cookie.split(';');
        let n = bits.length;

        for (let i = 0; i < n; i++) {
            let keyval = bits[i].split('=');

            if ((2 == keyval.length) && (keyval[0].trim() == search)) {
                val = keyval[1].trim();
                break;
            }
        }
    }

    return val;
};


if (document.querySelector('.promotion-bar')) {

    let hasPromo = document.querySelector('.promotion-bar')

    if (hasPromo) {

        let headerContainer = document.querySelector('.header-block');
        let mastheadContainer = document.querySelector('.bi-masthead');
        let postHeader = document.querySelector('.post-main-header');
        let promoBar = document.querySelector('.promotion-bar');
        let hidePromoLink = document.querySelector('.promotion-bar .close');
        let vidHeader = document.querySelector('.bg-vid-header');
        let navBar = document.querySelector('.main-navigation');

        let promoHeight = hasPromo.offsetHeight;
        let promoHeightPx = promoHeight + "px";

        if (headerContainer) {
            headerContainer.classList.add('promotional');
            headerContainer.style.marginTop = promoHeightPx;
        }

        if (mastheadContainer) {
            mastheadContainer.classList.add('promotional');
            mastheadContainer.style.marginTop = promoHeightPx;
        }

        if (postHeader) {
            postHeader.classList.add('promotional');
            postHeader.style.marginTop = promoHeightPx;
        }

        // if(navBar) {
        //     navBar.classList.add('promotional');
        //     navBar.style.marginTop = promoHeightPx;
        // }

        document.body.classList.add('promobar');

        if (vidHeader) {
            vidHeader.style.marginTop = 0;
        }

        hidePromoLink.addEventListener('click', function (e) {

            e.preventDefault();
            e.stopPropagation();

            promoBar.style.transform = 'translate(0, -150px)';
            document.body.classList.remove('promobar');

            docSetCookie('/', 'wp-brightlocal_promo_bar_hidden', 'true', 30);

            setTimeout(function () {
                promoBar.parentNode.removeChild(promoBar);

                if (headerContainer) {
                    headerContainer.classList.remove('promotional');
                    headerContainer.style.marginTop = 0;
                }

                if (mastheadContainer) {
                    mastheadContainer.classList.remove('promotional');
                    mastheadContainer.style.marginTop = 0;
                }

                if (postHeader) {
                    postHeader.classList.remove('promotional');
                    postHeader.style.marginTop = 0;
                }

                if (vidHeader) {
                    vidHeader.style.marginTop = '56px';
                }


            }, 1);
        });
    }
}

// Function to adjust the next sibling element position
const adjustNextSiblingPosition = () => {
    const pageHeader = document.getElementById('page-header');
    const promoBar = document.querySelector('.promotion-bar');

    if (promoBar) {
        let nextSibling = pageHeader.nextElementSibling;

        while (nextSibling && nextSibling.tagName !== 'DIV' && nextSibling.tagName !== 'SECTION') {
            nextSibling = nextSibling.nextElementSibling;
        }

        if (pageHeader && nextSibling && (nextSibling.tagName === 'DIV' || nextSibling.tagName === 'SECTION')) {
            const promoHeight = promoBar.offsetHeight;
            nextSibling.style.marginTop = promoHeight + 'px';
        }
    }
};

// Call the adjustNextSiblingPosition function on page load and window resize
window.addEventListener('load', adjustNextSiblingPosition);
window.addEventListener('resize', adjustNextSiblingPosition);
